import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Tooltip
} from '@mui/material';

import ClearIcon from '@mui/icons-material/Clear';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

const MODAL_WIDTH = {
    small: '60%',
    medium: '80%',
    large: '90%',
}

const MODAL_HEIGHT = {
    small: 'calc(60vh - 1rem)',
    medium: 'calc(80vh - 1rem)',
    large: 'calc(90vh - 1rem)',
}

export default function ModalView({ open, size, title, children, onClose, disable = false, showTitle = true, customActionsToolbar = <></> }) {
    const [fullScreen, setFullScreen] = useState(false);

    const modalSize = size ?? 'medium';

    const style = {
        position: 'absolute',
        backgroundColor: '#f9f9f9',
        margin: '0.5rem',
        borderRadius: '0.2rem',
    }

    const styleFullScreen = {
        ...style,
        height: 'calc(100vh - 1rem)',
        width: 'calc(100vw - 1rem)',
    };

    const styleNoFullScreen = {
        ...style,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: MODAL_HEIGHT[modalSize],
        width: MODAL_WIDTH[modalSize],
    };

    const handleOpenFullScreen = () => setFullScreen(true);

    const handleCloseFullScreen = () => setFullScreen(false);
    return (

        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={fullScreen ? styleFullScreen : styleNoFullScreen}>
                <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: disable ? 'rgba(255, 255, 255, 0.5)' : 'transparent', zIndex: disable ? 10 : -1 }} />
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: 'solid 1px #9f9f9f' }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ pl: 2 }}>
                        {showTitle &&
                            <>{title}</>
                        }
                    </Typography>
                    <Box>
                        <span style={{ marginRight: '1rem' }}>{customActionsToolbar}</span>
                        {
                            fullScreen
                                ? <Tooltip title="Fullscreen" placement="top"><IconButton onClick={handleCloseFullScreen}><CloseFullscreenIcon fontSize='small' /></IconButton></Tooltip>
                                : <Tooltip title="Fullscreen" placement="top"><IconButton onClick={handleOpenFullScreen}><OpenInFullIcon fontSize='small' /></IconButton></Tooltip>
                        }
                        <Tooltip title="Close" placement="top"><IconButton onClick={onClose}><ClearIcon /></IconButton></Tooltip>
                    </Box>
                </Box>
                <Box sx={{ height: 'calc(100% - 41px)', p: 2, overflowY: 'auto' }} id="modal-modal-description" >
                    {children}
                </Box>
            </Box>
        </Modal>
    )
}
